import { create } from 'zustand';
import { DialerStoreType } from '../types/store/dialer.types';
import { DIALER_NUMBER_LIMIT, dialerNavigationStates } from '../constants/dialer.constants';

const defaultValues = {
  isKeypadOpen: true,
  keypadNumber: '',
  countryCode: '',
  currentNavigation: dialerNavigationStates.dialer,
  debounceKeypadNumber: '',
};

export const useDialerStore = create<DialerStoreType>((set) => ({
  ...defaultValues,
  channelId: null,
  openKeypad: () => set({ isKeypadOpen: true }),
  closeKeypad: () => set({ isKeypadOpen: false }),
  setDialerChannelId: (channelId) => set({ channelId }),
  resetDialer: () => set({ ...defaultValues }),
  appendKeypadNumber: (num) => set((state) => ({ keypadNumber: state.keypadNumber + num })),
  setKeypadNumber: (num) => (num.length <= DIALER_NUMBER_LIMIT ? set({ keypadNumber: num }) : undefined),
  setDebounceKeypadNumber: (debounceKeypadNumber) => set({ debounceKeypadNumber }),
  resetKeypadNumber: () => set({ keypadNumber: '' }),
  removeKeypadNumber: () =>
    set((state) => {
      if (state.keypadNumber.length) {
        const newNumber = state.keypadNumber.substring(0, state.keypadNumber.length - 1);

        return { keypadNumber: newNumber };
      } else {
        return { keypadNumber: '' };
      }
    }),
  setCountryCode: (countryCode) => set({ countryCode }),
  openCalls: () => set({ currentNavigation: dialerNavigationStates.dialer }),
  openContacts: () => set({ currentNavigation: dialerNavigationStates.contacts }),
  openSettings: () => set({ currentNavigation: dialerNavigationStates.settings }),
}));
